
<div class="authorized-dialog">

  <!-- INTESTAZIONE INTERNA -->
  <div class="authorized-header">
    <div class="authorized-header-icon">
      <i class="pi pi-users"></i>
    </div>

    <div class="authorized-header-text">
      <h2>Selezione iscritti</h2>
      <p>
        Seleziona gli utenti da associare all'operazione.
      </p>
    </div>
  </div>

  <!-- BARRA STRUMENTI -->
  <div class="authorized-toolbar">

    <div class="authorized-toolbar-left">
      <div class="authorized-selected-count">
        <i class="pi pi-user-plus"></i>

        <span>
          <strong>{{ selectedUsers.length }}</strong>
          {{ selectedUsers.length === 1 ? 'utente selezionato' : 'utenti selezionati' }}
        </span>
      </div>
    </div>

    <div class="authorized-toolbar-actions">

      <p-toggleButton
        *ngIf="allowSimplifiedView"
        onLabel="Vista semplificata"
        offLabel="Vista utenti"
        onIcon="pi pi-filter"
        offIcon="pi pi-list"
        [(ngModel)]="simplifiedView"
        styleClass="authorized-view-toggle"
      ></p-toggleButton>

      <p-button
        *ngIf="simplifiedView"
        icon="pi pi-filter-slash"
        label="Rimuovi filtri"
        styleClass="p-button-outlined authorized-reset-button"
        (onClick)="setFiltersToDefault()"
      ></p-button>

    </div>
  </div>

  <!-- VISTA SEMPLIFICATA -->
  <div class="authorized-content" *ngIf="simplifiedView">

    <div class="authorized-section-heading">
      <h3>Filtra gli iscritti</h3>
      <p>
        Seleziona una o più voci nei riquadri per individuare
        gli utenti desiderati.
      </p>
    </div>

    <div class="authorized-filter-grid">

      <!-- UTENTI INTERNI / ESTERNI -->
      <section class="authorized-filter-card">
        <div class="authorized-filter-header">
          <div class="authorized-filter-icon">
            <i class="pi pi-users"></i>
          </div>

          <h4>Utenti interni ed esterni</h4>
        </div>

        <p-listbox
          (onChange)="externalFilterChanged($event)"
          [multiple]="true"
          [options]="externals"
          [listStyle]="{'max-height': '220px'}"
          styleClass="authorized-listbox"
        >
          <ng-template let-external pTemplate="item">
            <div class="authorized-filter-option">
              <span>
                {{ external.value === 'true' ? 'Esterni' : 'Interni' }}
              </span>

              <span class="authorized-option-count">
                {{ external.count }}
              </span>
            </div>
          </ng-template>
        </p-listbox>
      </section>

      <!-- COMPARTI -->
      <section class="authorized-filter-card">
        <div class="authorized-filter-header">
          <div class="authorized-filter-icon">
            <i class="pi pi-briefcase"></i>
          </div>

          <h4>Comparti</h4>
        </div>

        <p-listbox
          (onChange)="sectorFilterChanged($event)"
          [multiple]="true"
          [options]="sectors"
          [listStyle]="{'max-height': '220px'}"
          styleClass="authorized-listbox"
        >
          <ng-template let-sector pTemplate="item">
            <div class="authorized-filter-option">
              <span>
                {{ sector.value !== '' ? sector.value : 'Vuoto' }}
              </span>

              <span class="authorized-option-count">
                {{ sector.count }}
              </span>
            </div>
          </ng-template>
        </p-listbox>
      </section>

      <!-- SEDI OPERATIVE -->
      <section class="authorized-filter-card">
        <div class="authorized-filter-header">
          <div class="authorized-filter-icon">
            <i class="pi pi-map-marker"></i>
          </div>

          <h4>Sedi operative</h4>
        </div>

        <p-listbox
          (onChange)="headquarterFilterChanged($event)"
          [multiple]="true"
          [options]="headquarters"
          [listStyle]="{'max-height': '220px'}"
          styleClass="authorized-listbox"
        >
          <ng-template let-headquarter pTemplate="item">
            <div class="authorized-filter-option">
              <span>
                {{ headquarter.value !== '' ? headquarter.value : 'Vuoto' }}
              </span>

              <span class="authorized-option-count">
                {{ headquarter.count }}
              </span>
            </div>
          </ng-template>
        </p-listbox>
      </section>

      <!-- RUOLI -->
      <section class="authorized-filter-card">
        <div class="authorized-filter-header">
          <div class="authorized-filter-icon">
            <i class="pi pi-id-card"></i>
          </div>

          <h4>Ruoli</h4>
        </div>

        <p-listbox
          (onChange)="roleFilterChanged($event)"
          [multiple]="true"
          [options]="roles"
          [listStyle]="{'max-height': '220px'}"
          styleClass="authorized-listbox"
        >
          <ng-template let-role pTemplate="item">
            <div class="authorized-filter-option">
              <span>
                {{ role.value !== '' ? role.value : 'Vuoto' }}
              </span>

              <span class="authorized-option-count">
                {{ role.count }}
              </span>
            </div>
          </ng-template>
        </p-listbox>
      </section>

      <!-- GRUPPI -->
      <section class="authorized-filter-card">
        <div class="authorized-filter-header">
          <div class="authorized-filter-icon">
            <i class="pi pi-sitemap"></i>
          </div>

          <h4>Gruppi</h4>
        </div>

        <p-listbox
          (onChange)="groupFilterChanged($event)"
          [multiple]="true"
          [options]="groups"
          [listStyle]="{'max-height': '220px'}"
          styleClass="authorized-listbox"
        >
          <ng-template let-group pTemplate="item">
            <div class="authorized-filter-option">
              <span>
                {{ group.value !== '' ? group.value : 'Vuoto' }}
              </span>

              <span class="authorized-option-count">
                {{ group.count }}
              </span>
            </div>
          </ng-template>
        </p-listbox>
      </section>

      <!-- CONTRATTO -->
      <section class="authorized-filter-card">
        <div class="authorized-filter-header">
          <div class="authorized-filter-icon">
            <i class="pi pi-file"></i>
          </div>

          <h4>Contratto</h4>
        </div>

        <p-listbox
          (onChange)="typeContractFilterChanged($event)"
          [multiple]="true"
          [options]="typeContract"
          [listStyle]="{'max-height': '220px'}"
          styleClass="authorized-listbox"
        >
          <ng-template let-contract pTemplate="item">
            <div class="authorized-filter-option">
              <span>
                {{ contract.value !== '' ? contract.value : 'Vuoto' }}
              </span>

              <span class="authorized-option-count">
                {{ contract.count }}
              </span>
            </div>
          </ng-template>
        </p-listbox>
      </section>

    </div>
  </div>

  <!-- VISTA COMPLETA DEGLI UTENTI -->
  <div class="authorized-content" *ngIf="!simplifiedView">

    <div class="authorized-section-heading">
      <h3>Elenco iscritti</h3>
      <p>
        Cerca gli utenti e selezionali tramite le caselle.
      </p>
    </div>

    <div class="authorized-table-container">

      <p-table
        #dt
        [value]="allUsers"
        [(selection)]="selectedUsers"
        (selectAllChange)="evaluateFilters()"
        [scrollable]="true"
        scrollDirection="both"
        scrollHeight="flex"
        [globalFilterFields]="['subscriber.name', 'subscriber.lastName']"
        styleClass="p-datatable-sm authorized-users-table"
      >

        <ng-template pTemplate="caption">
          <div class="authorized-table-toolbar">

            <div class="authorized-table-title">
              <i class="pi pi-list"></i>
              <span>Utenti disponibili</span>
            </div>

            <div class="authorized-search">

              <p-button
                *ngIf="search !== ''"
                icon="pi pi-filter-slash"
                styleClass="p-button-outlined"
                (onClick)="search = ''; dt.filterGlobal(search, 'contains')"
              ></p-button>

              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>

                <input
                  pInputText
                  type="text"
                  [(ngModel)]="search"
                  (ngModelChange)="dt.filterGlobal(search, 'contains')"
                  placeholder="Cerca per nome o cognome..."
                />
              </span>

            </div>

          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>

            <th pSortableColumn="email">
              Email
              <p-sortIcon field="email"></p-sortIcon>
            </th>

            <th pSortableColumn="subscriber.name">
              Nome
              <p-sortIcon field="subscriber.name"></p-sortIcon>
            </th>

            <th pSortableColumn="subscriber.lastName">
              Cognome
              <p-sortIcon field="subscriber.lastName"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-signin>
          <tr>
            <td>
              <p-tableCheckbox [value]="signin"></p-tableCheckbox>
            </td>

            <td>{{ signin.email }}</td>

            <td>
              {{ signin.subscriber.name }}
            </td>

            <td>
              {{ signin.subscriber.lastName }}
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4">
              <div class="authorized-table-empty">
                <i class="pi pi-search"></i>
                Nessun utente trovato.
              </div>
            </td>
          </tr>
        </ng-template>

      </p-table>

    </div>
  </div>

  <!-- FOOTER -->
  <div class="authorized-footer">

    <p-button
      label="Annulla"
      icon="pi pi-times"
      severity="danger"
      [outlined]="true"
      (onClick)="cancel()"
    ></p-button>

    <div class="authorized-footer-right">

      <span class="authorized-footer-count">
        {{ selectedUsers.length }}
        {{ selectedUsers.length === 1 ? 'utente' : 'utenti' }}
      </span>
      <p-button
        label="Conferma selezione"
        icon="pi pi-check"
        (onClick)="confirm()"
      ></p-button>
    </div>
  </div>
</div>